import { axios } from 'common/utils'
import { Attribute } from 'common/types/entities/mongo/sub'

export const fetchAttributeById = async (id: string): Promise<Attribute> => {
  const result = await axios.get<Attribute>(`/v1/product-attributes/${id}`)
  return result && result.data
}

export const fetchAttributeByIds = async (ids: string[]): Promise<Attribute[]> => {
  const result = await axios.get<Attribute[]>(`/v1/product-attributes/`, { params: { ids } })
  return result && (result.data || [])
}

export const fetchAttributeByValueIds = async (valueIds: string[]): Promise<Attribute[]> => {
  const result = await axios.get<Attribute[]>(`/v1/product-attributes/`, { params: { valueIds } })
  return result && (result.data || [])
}
